module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("This is a work of fiction. All of the characters, organizations, and events portrayed in this novel are either products of the author’s imagination or are used fictitiously.")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE WORLD INSIDE")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_vm._v("Copyright © 1971 by Agberg, Ltd.")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_vm._v("Preface copyright © 2010 by Agberg, Ltd.")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_vm._v("Originally published in 1971 by Doubleday")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_vm._v("All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_vm._v("An Orb Book"), _c('br'), _vm._v("Published by Tom Doherty Associates, LLC"), _c('br'), _vm._v("175 Fifth Avenue"), _c('br'), _vm._v("New York, NY 10010")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_c('a', {
    attrs: {
      "href": "http://www.tor-forge.com",
      "target": "_blank"
    }
  }, [_vm._v("www.tor-forge.com")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_vm._v("ISBN 978-0-7653-2432-0")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_vm._v("First Orb Edition: March 2010")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_vm._v("0  9  8  7  6  5  4  3  2  1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49af5c96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 72
// module chunks = 0